module.exports = __webpack_public_path__ + "img/ng_2.9b0fc1b2.png";